import { useState, useEffect, useCallback } from 'react';

var API = 'https://api.algrok.com';

function fmtINR(n) {
  if (n == null || isNaN(n)) return '--';
  var sign = n < 0 ? '−' : '+';
  return sign + '₹' + Math.abs(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
}
function fmtGEX(v) {
  if (v == null || isNaN(v)) return '--';
  var a = Math.abs(v);
  return a >= 1e7 ? (v / 1e7).toFixed(2) + 'Cr' : a >= 1e5 ? (v / 1e5).toFixed(1) + 'L' : String(Math.round(v));
}

var GEXWallsM = function () {
  var [state, setState] = useState(null);

  var fetchState = useCallback(function () {
    fetch(API + '/gexwalls/state').then(function (r) { return r.json(); }).then(function (d) {
      if (d && !d.error) setState(d);
    }).catch(function () {});
  }, []);

  useEffect(function () {
    fetchState();
    var id = setInterval(fetchState, 1000);
    function wake() { if (!document.hidden) fetchState(); }
    document.addEventListener('visibilitychange', wake);
    return function () { clearInterval(id); document.removeEventListener('visibilitychange', wake); };
  }, [fetchState]);

  var cfg = (state && state.config) || {};
  var walls = (state && state.walls) || {};
  var pos = state && state.position;
  var st = (state && state.stats) || {};
  var trades = (state && state.trades) || [];
  var card = { background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 12, padding: '12px 14px', marginBottom: 10 };

  return (
    <div style={{ padding: '14px 14px 80px', color: '#e5e7eb', fontFamily: 'inherit', height: '100%', overflowY: 'auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
        <span style={{ fontSize: 19, fontWeight: 800 }}>⚡ GEX Walls</span>
        <span style={{ fontSize: 8, fontWeight: 800, letterSpacing: 1, color: '#38bdf8', background: 'rgba(56,189,248,0.1)', border: '1px solid rgba(56,189,248,0.4)', borderRadius: 6, padding: '2px 6px' }}>SIGNALS ONLY</span>
        <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: cfg.enabled !== false ? '#22c55e' : '#6b7a8d' }}>{cfg.enabled !== false ? '● ON' : '○ OFF'}</span>
        {state && state.day_stopped ? <span style={{ fontSize: 8, fontWeight: 800, color: '#ef4444', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.45)', borderRadius: 6, padding: '2px 6px' }}>STOPPED · {state.day_stopped}</span> : null}
      </div>
      <div style={{ fontSize: 9, color: '#6b7a8d', marginBottom: 12 }}>
        Sells the gamma walls · FULL CHAIN · rolls &gt;{cfg.roll_threshold_pct || 10}%×{cfg.roll_confirm_checks || 2} · settings on desktop
      </div>

      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 8 }}>
          WALLS · ATM {walls.atm || '--'} · {walls.time || '--'}
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <div style={{ flex: 1, background: '#0d1524', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
            <div style={{ fontSize: 8, fontWeight: 800, color: '#ef4444' }}>CE γWALL</div>
            <div style={{ fontSize: 18, fontWeight: 800 }}>{walls.ce ? walls.ce.strike : '--'}</div>
            <div style={{ fontSize: 10, color: '#ef4444', fontWeight: 800 }}>{walls.ce ? fmtGEX(walls.ce.gex) : ''}</div>
          </div>
          <div style={{ flex: 1, background: '#0d1524', borderRadius: 8, padding: '8px 10px', textAlign: 'center' }}>
            <div style={{ fontSize: 8, fontWeight: 800, color: '#22c55e' }}>PE γWALL</div>
            <div style={{ fontSize: 18, fontWeight: 800 }}>{walls.pe ? walls.pe.strike : '--'}</div>
            <div style={{ fontSize: 10, color: '#22c55e', fontWeight: 800 }}>{walls.pe ? fmtGEX(walls.pe.gex) : ''}</div>
          </div>
        </div>
      </div>

      <div style={card}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
          <span style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677' }}>POSITION{pos ? ' · ' + pos.shape : ''}</span>
          {pos ? <span style={{ fontSize: 12, fontWeight: 800, color: (pos.unrealized || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(pos.unrealized)}</span> : null}
        </div>
        {pos ? (pos.legs || []).map(function (l, i) {
          return <div key={i} style={{ fontSize: 11, color: '#8b98a9', padding: '3px 0' }}>
            SELL {l.strike} {l.side} @ {l.entry} → {l.ltp}
            <span style={{ float: 'right', fontWeight: 800, color: (l.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(l.pnl)}</span>
          </div>;
        }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '10px 0' }}>
          {state && state.entered_today ? 'Done for the day.' : 'Flat — enters at ' + (cfg.entry_time || '09:17') + '.'}
        </div>}
      </div>

      <div style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
        {[['DAY', st.day_pnl], ['REAL', st.realized], ['UNREAL', st.unrealized]].map(function (x, i) {
          return <div key={i} style={{ flex: 1, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '7px 4px', textAlign: 'center' }}>
            <div style={{ fontSize: 8, fontWeight: 800, color: '#556677' }}>{x[0]}</div>
            <div style={{ fontSize: 13, fontWeight: 800, color: (x[1] || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(x[1])}</div>
          </div>;
        })}
        <div style={{ flex: 1, background: '#0a0f1c', border: '1px solid #1f2937', borderRadius: 10, padding: '7px 4px', textAlign: 'center' }}>
          <div style={{ fontSize: 8, fontWeight: 800, color: '#556677' }}>ROLLS</div>
          <div style={{ fontSize: 13, fontWeight: 800, color: '#fbbf24' }}>{(st.rolls_ce || 0) + (st.rolls_pe || 0)}</div>
        </div>
      </div>

      <div style={card}>
        <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: 1, color: '#556677', marginBottom: 8 }}>TRADES &amp; ROLLS</div>
        {trades.length ? trades.map(function (t, i) {
          return <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 6, fontSize: 10, padding: '5px 0', borderBottom: '1px solid #131a2a', flexWrap: 'wrap' }}>
            <span style={{ fontWeight: 800, color: t.type === 'ROLL' ? '#fbbf24' : '#38bdf8' }}>{t.type === 'ROLL' ? 'ROLL ' + t.dir : t.dir}</span>
            <span style={{ color: '#6b7a8d' }}>{t.reason}</span>
            <span style={{ fontWeight: 800, color: (t.pnl || 0) >= 0 ? '#22c55e' : '#ef4444' }}>{fmtINR(t.pnl)}</span>
          </div>;
        }) : <div style={{ fontSize: 10, color: '#6b7a8d', textAlign: 'center', padding: '8px 0' }}>None yet.</div>}
      </div>
    </div>
  );
};

export default GEXWallsM;
